import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Box } from "@mui/material";
import SalesDocumentRowTableRow from "./SalesDocumentRowTableRow";

const grCell = { padding: "0px", margin: "2px 8px 2px 0px" };
const grCell_last = { padding: "0px", margin: "2px 2px 2px 0px" };
const grHeader = {
  display: "grid",
  gridTemplateColumns:
    "28px 0.6fr 0.9fr 0.6fr 108px 108px 168px 78px 78px 0.39fr 64px",
  width: "calc(100vw - (100vw - 100%))",
  height: "25px",
  paddingBottom: "26px",
  marginBottom: "10px",
  borderBottom: "1px solid rgba(0, 0, 0, 0.22)",
};

const SalesDocumentRowTable = ({
  companyId,
  settings,
  rows = [],
  articles,
  readOnly,
  onAddRow,
  onChangeRow,
  onDeleteRow,
  onMoveRow,
}) => {
  const handleDragEnd = (result) => {
    if (readOnly) return;

    const { source, destination } = result;
    if (!destination) return;

    onMoveRow?.({
      fromIndex: source.index,
      toIndex: destination.index,
    });
  };

  return (
    <Box id="container">
      {/* Header */}
      <Box sx={grHeader}>
        <Box sx={grCell} />
        {settings?.tableLabels?.map((h, i) => (
          <Box align={h.align} sx={grCell} key={i}>
            {h.label}
          </Box>
        ))}
        <Box sx={grCell_last} />
      </Box>

      {/* Drag & Drop Context */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="salesDocumentRowTable" isDropDisabled={readOnly}>
          {(provided) => (
            <Box ref={provided.innerRef} {...provided.droppableProps}>
              {rows.map((row, index) => (
                <Draggable
                  key={row.id ?? `row-${index}`}
                  draggableId={String(row.id ?? `row-${index}`)}
                  index={index}
                  isDragDisabled={readOnly}
                >
                  {(draggableProvided) => {
                    const originalStyle = draggableProvided.draggableProps.style;

                    // Axis lock: prevent horizontal drift
                    const style = originalStyle?.transform
                      ? {
                        ...originalStyle,
                        transform: `translate(0px, ${originalStyle.transform.split(",")[1]}`,
                      }
                      : originalStyle;

                    return (
                      <Box
                        ref={draggableProvided.innerRef}
                        {...draggableProvided.draggableProps}
                        style={style}
                      >
                        <SalesDocumentRowTableRow
                          articles={articles}
                          companyId={companyId}
                          disableDelete={rows.length < 2}
                          index={index}
                          readOnly={readOnly}
                          onAddRow={onAddRow}
                          onChangeRow={onChangeRow}
                          onDeleteRow={onDeleteRow}
                          row={row}
                          settings={settings}
                          dragHandleProps={draggableProvided.dragHandleProps}
                        />
                      </Box>
                    );
                  }}
                </Draggable>
              ))}
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </DragDropContext>
    </Box>
  );
};

export default SalesDocumentRowTable;
